import { query } from "@sinao/core-js";

const models = {
	state: () => ({
		models: [],
		selectedModel: null
	}),
	mutations: {
		models(state, payload) {
			state.models = [{ id: 0, name: "" }, ...payload];
		},
		selectedModel(state, payload) {
			state.selectedModel = payload;
		}
	},
	getters: {
		getModelById: state => id => state.models.find(model => id === model.id),
		getModelIndexById: state => id => state.models.findIndex(model => id === model.id)
	},
	actions: {
		async models({ commit }, appId) {
			try {
				const response = await query({
					operationId: "app.documents.sales.models.list",
					params: {
						appId,
						"expand[0]": "count_usage_in_recurring_invoices"
					}
				});

				commit("models", response.data);

				return response.data;
			} catch (error) {
				throw new Error(error);
			}
		},
		async loadModel({ getters, dispatch }, id) {
			if (!id) {
				throw new Error("id required to load a model");
			}

			const model = getters.getModelById(id);

			if (model) {
				dispatch("loadDocument", { data: model, force: true });
			}
		}
	}
};

export default models;
